import { createContext, useContext, useEffect, useState, useCallback } from "react";
import client from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const PermissionsContext = createContext();

export function PermissionsProvider({ children }) {
  const { user } = useAuth();
  const [perms, setPerms] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [hiddenNav, setHiddenNav] = useState([]);
  const [showSubtypes, setShowSubtypes] = useState(true);

  const load = useCallback(() => {
    if (!user) { setPerms(null); return; }
    client.get("/me/permissions").then(({ data }) => { setPerms(data.permissions); setIsAdmin(data.is_admin); setHiddenNav(data.hidden_nav || []); setShowSubtypes(data.show_subtypes !== false); }).catch(() => {});
  }, [user]);

  useEffect(() => { load(); }, [load]);

  const can = useCallback((page, action) => {
    if (isAdmin) return true;
    if (!perms) return true; // optimistic until loaded (backend still enforces)
    const v = perms[page]?.[action];
    if (v && typeof v === "object") return Boolean(v.own || v.others);
    return Boolean(v);
  }, [perms, isAdmin]);

  const canScope = useCallback((page, action, isOwn) => {
    if (isAdmin) return true;
    if (!perms) return true;
    const v = perms[page]?.[action];
    if (v && typeof v === "object") return Boolean(isOwn ? v.own : v.others);
    return Boolean(v);
  }, [perms, isAdmin]);

  return (
    <PermissionsContext.Provider value={{ perms, isAdmin, can, canScope, hiddenNav, showSubtypes, reload: load }}>
      {children}
    </PermissionsContext.Provider>
  );
}

export const usePermissions = () => useContext(PermissionsContext);
